import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { AuditHistoryVm } from '../generated/Models/AuditHistoryVm';
import { TableComponent } from '../table/table.component';

@Component({
    selector: 'pcg-shared-audit-history',
    templateUrl: './audit-history.component.html',
    styleUrls: ['./audit-history.component.scss'],
    standalone: false
})
export class AuditHistoryComponent implements OnInit {

	@ViewChild(TableComponent, { static: true }) table!: TableComponent<AuditHistoryVm>;

	@Input() id!: number;
    @Input() viewModel!: string;
    @Input() auditHistoryName!: string;
	@Input() showTitle = true;

	columns = AuditHistoryVm.ColumnDefs;
	auditName!: string;
	filters = {
		id: null as number | null,
		viewModel: null as string | null,
		auditName: null as string | null,
	};

	sharedServiceObject: any;

	constructor(
		public title: Title
		, private activatedRoute: ActivatedRoute
		, private router: Router
	) {
		title.setTitle('Audit History');
		this.sharedServiceObject = this.router.currentNavigation()?.extras.state;
	}

	ngOnInit() {
		if (this.showTitle) { this.title.setTitle('Audit History'); }
        if (this.id && this.viewModel && this.auditHistoryName) {
            this.filters.id = this.id;
            this.filters.viewModel = this.viewModel;
            this.filters.auditName = this.auditHistoryName;
        } else { this.getFiltersFromLocalStorage(); }
		
		if (this.filters.viewModel == null && this.filters.auditName == null && this.sharedServiceObject != null) {
			this.filters.viewModel = this.sharedServiceObject.vmType;
			this.filters.auditName = this.sharedServiceObject.auditName;
		}
	}

	getFiltersFromLocalStorage() {
		this.filters.id = this.activatedRoute.snapshot.params['id'];
		this.filters.viewModel = localStorage?.getItem('vmType');
		this.filters.auditName = localStorage?.getItem('auditName');
	}
}
